import styled from 'styled-components';

export const videoDiv = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
  background: #000000;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  font-family: "Basis Grotesque Pro";
  border-radius: 8px;
  font-weight: normal;
  & button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const videoElementDiv = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`;
export const videoMenuDiv = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-transition: 0.4s;
  transition: bottom 0.4s;
  z-index: 3;
  padding: 4px 4px;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(0, 0, 0, 0.07),
    rgba(0, 0, 0, 0.25),
    rgba(0, 0, 0, 0.5)
  );
  &:hover {
    bottom: 0 !important;
  }
`;
export const playPauseDiv = styled.div`
  height: 30px;
  width: 30px;
  position: relative;
`;
export const playIconBtn = styled.button`
  background: none;
  width: 0;
  height: 0;
  padding: 0;
  margin: 6px;
  border-style: solid;
  border-width: 8px 0 8px 16px;
  border-color: transparent transparent transparent #ffffff;
  outline: none;
  cursor: pointer;
`;
export const ScreenPlayDiv = styled.div`
  background: none;
  width: 50px;
  height: 50px;
  padding: 0;
  margin: 6px;
  outline: none;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  -webkit-transition: 0.4s;
  transition: opacity 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 18px;
    height: 21px;
  }
`;
export const PlayDiv = styled.div`
  background: none;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 5px;
  -webkit-transition: 0.4s;
  transition: opacity 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  & img {
    width: 10px;
    height: 12px;
  }
`;
export const pauseIconBtn = styled.button`
  background: none;
  width: 0;
  height: 16px;
  padding: 3px;
  margin: 6px;
  border-style: solid;
  border-width: 0 5px;
  border-color: transparent #ffffff transparent #ffffff;
  outline: none;
  cursor: pointer;
`;
export const ScreenPauseDiv = styled.div`
  background: none;
  width: 0;
  height: 40px;
  padding: 6px;
  margin: 6px;
  border-style: solid;
  border-width: 0 14px;
  border-color: transparent #ffffff transparent #ffffff;
  outline: none;
  cursor: pointer;
  -webkit-transition: 0.4s;
  transition: opacity 0.4s;
`;
export const playHoverDiv = styled.div`
  height: 9px;
  width: 28px;
  border-radius: 4px;
  background: #ea532c;
  opacity: 0.5;
  -webkit-transition: 0.2s;
  transition: height opacity 0.2s;
  bottom: -10px;
  position: absolute;
  z-index: -1;
  ${playPauseDiv}:hover & {
    height: 40px;
  }
  ${playPauseDiv}:active & {
    opacity: 1;
  }
`;
export const muteUnmuteDiv = styled.div`
  height: 36px;
  width: 36px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
export const muteHoverDiv = styled.div`
  height: 9px;
  width: 30px;
  border-radius: 4px;
  background: #ea532c;
  opacity: 0.5;
  -webkit-transition: 0.2s;
  transition: height opacity 0.4s;
  bottom: -10px;
  position: absolute;
  z-index: -1;
  ${muteUnmuteDiv}:hover & {
    height: 140px;
  }
  ${muteUnmuteDiv}:active & {
    opacity: 1;
  }
`;
export const fullScrIconBtn = styled.button`
  height: 36px;
  width: 36px;
  background: none;
  border: none;
  padding: 0px;
  margin: 0px;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const muteIconBtn = styled.button`
  height: 36px;
  width: 36px;
  background: none;
  border: none;
  padding: 0px;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const seekProgressDiv = styled.div`
  width: inherit;
  display: flex;
  position: relative;
  align-items: center;
  margin: 0 7px;
`;
export const seekProgress = styled.progress`
  -webkit-appearance: none;
  width: 100%;
  position: absolute;
  z-index: 2;
  height: 3px;
  overflow: hidden;
  border-radius: 3px;
  -webkit-appearance: none;
  -webkit-transition: 0.2s;
  transition: height 0.2s;
  &::-webkit-progress-bar {
    background: rgba(255, 255, 255, 0.5);
    height: 6px;
  }
  &::-webkit-progress-value {
    background-color: #FF2C91;
    height: 6px;
  }
`;
export const sliderInput = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  background: none;
  outline: none;
  margin: 0px 7px;
  border-radius: 3px;
  -webkit-transition: 0.2s;
  transition: all 0.2s;
  transition: height 0.2s;
  position: absolute;
  z-index: 3;
  :hover ~ ${seekProgress} {
    height: 6px;
  }
  :hover::-webkit-slider-thumb {
    opacity: 1;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-transition: 0.2s;
    transition: height 0.2s;
    transition: opacity 0.2s;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    appearance: none;
    width: 14px;
    height: 14px;
    opacity: 0;
    border-radius: 7px;
    margin-left: -7px;
    background: #FF2C91;
    cursor: pointer;
  }
  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    display: none;
    background: #FF2C91;
    cursor: pointer;
    transition: height 0.2s;
    transition: width 0.2s;
  }
`;
export const hoverAllDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: absolute;
  z-index: 2;
  bottom: 0;
`;

export const playIconDiv = styled.div`
  position: absolute;
  z-index: 2;
  background: none;
  width: 0;
  height: 0;
  padding: 0;
  margin: 6px;
  border-style: solid;
  border-width: 8px 0 8px 16px;
  border-color: transparent transparent transparent #ffffff;
  outline: none;
  cursor: pointer;
`;
export const onScreenIconDiv = styled.div`
  position: absolute;
  background: none;
  z-index: 2;
  opacity: 1;
  /* background: rgba(34,67,43,0.5); */
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const videoOverlayDiv = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const volumeBarDiv = styled.div`
  height: 84px;
  width: 36px;
  position: absolute;
  bottom: 36px;
  z-index: 2;
  overflow: hidden;
  -webkit-transition: 0.4s;
  transition: height 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const volumeProgress = styled.progress`
  -webkit-appearance: none;
  position: absolute;
  z-index: 2;
  height: 2px;
  width: 60px;
  overflow: hidden;
  border-radius: 3px;
  -webkit-appearance: none;
  -webkit-transition: 0.2s;
  transition: height 0.2s;
  transform: rotate(270deg);
  &::-webkit-progress-bar {
    background: rgba(255, 255, 255, 0.5);
    height: 6px;
  }
  &::-webkit-progress-value {
    background-color: #FF2C91;
    height: 6px;
  }
`;
export const volumeSliderInput = styled.input`
  -webkit-appearance: none;
  width: 60px;
  height: 6px;
  background: none;
  outline: none;
  -webkit-transition: 0.2s;
  transition: all 0.2s;
  transform: rotate(270deg);
  margin: 0px;
  position: absolute;
  z-index: 3;
  :hover ~ ${volumeProgress} {
    height: 4px;
  }
  :hover::-webkit-slider-thumb {
    opacity: 1;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-transition: 0.2s;
    transition: height 0.2s;
    transition: opacity 0.2s;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    appearance: none;
    opacity: 0;
    width: 8px;
    height: 8px;
    border-radius: 7px;
    background: #FF2C91;
    cursor: pointer;
  }
  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    display: none;
    background: #FF2C91;
    cursor: pointer;
    transition: height 0.2s;
    transition: width 0.2s;
  }
`;
export const TimeDiv = styled.div`
  font-size: 10px;
  color: #ffffff;
  white-space: nowrap;
`;